import { CreditCard, ExternalLink, TrendingUp } from "lucide-react";
import { Button } from "../ui/button";

const PURCHASE_URL = "https://host.kemo-tv.shop/client/store/reseller-packages";

const pricingTiers = [
  { credits: 100, price: 170, perCredit: 1.70 },
  { credits: 200, price: 332, perCredit: 1.66 },
  { credits: 400, price: 644, perCredit: 1.61 },
  { credits: 740, price: 1100, perCredit: 1.49, bestValue: true },
  { credits: 1550, price: 2300, perCredit: 1.48 },
];

export default function CreditManagement() {
  const openPurchase = () => window.open(PURCHASE_URL, '_blank');

  return (
    <div className="space-y-6" data-testid="credit-management">
      {/* Purchase Credits Card */}
      <div className="card p-6 border border-[#D4AF37]/30 bg-gradient-to-br from-[#1E1B4B]/30 to-transparent">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-[#D4AF37]/20 flex items-center justify-center">
              <CreditCard className="w-7 h-7 text-[#D4AF37]" />
            </div>
            <div>
              <h3 className="font-['Playfair_Display'] text-xl font-bold text-white">Purchase Credits</h3>
              <p className="text-white/50 text-sm">Replenish your credit balance</p>
            </div>
          </div>
          <Button onClick={openPurchase} className="btn-primary flex items-center gap-2" data-testid="buy-credits-btn">
            Buy Credits Now <ExternalLink className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {/* Credit Pricing Tiers */}
      <div className="card p-6 border border-white/10">
        <div className="flex items-center gap-3 mb-6">
          <TrendingUp className="w-5 h-5 text-[#00D4FF]" />
          <h3 className="font-['Playfair_Display'] text-lg font-bold text-white">Credit Pricing Tiers</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-testid="credit-tiers">
          {pricingTiers.map((tier) => (
            <div 
              key={tier.credits} 
              className={`relative p-4 border transition-all hover:scale-105 cursor-pointer ${
                tier.bestValue 
                  ? 'border-[#D4AF37] bg-[#D4AF37]/10' 
                  : 'border-white/10 hover:border-[#00D4FF]/50'
              }`} 
              onClick={openPurchase}
              data-testid={`tier-${tier.credits}`}
            >
              {tier.bestValue && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-black text-xs font-bold px-2 py-0.5 uppercase">
                  Best Value
                </div>
              )}
              <div className="text-center">
                <p className="text-2xl font-bold text-white">{tier.credits}</p>
                <p className="text-white/50 text-sm mb-2">Credits</p>
                <p className="text-xl font-bold text-[#D4AF37]">${tier.price.toLocaleString()}</p>
                <p className="text-[#00D4FF] text-sm mt-2">${tier.perCredit.toFixed(2)}/credit</p>
              </div>
              <Button className={`w-full mt-4 text-sm ${
                tier.bestValue 
                  ? 'bg-[#D4AF37] text-black hover:bg-[#C5A059]' 
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}>
                Buy {tier.credits}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
